import React from 'react'
import { GetServerSideProps, NextPage } from 'next'
import { readToken } from '../../lib/sanity.api'

import {
  getStateBySlug,
  getClient,
  getGetAllCategoriesInState,
  getGetAllProductsInLocation,
  getGetAllCitiesInState,
} from '../../lib/sanity.client'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { PageBanner } from '../../components/PageBanner'
import PageHead from '../../components/shared/PageHead'
import TileSlider from '../../components/structure/TileSlider'
import { FAQ } from '../../components/shared/FAQ'
import { Description } from '../../components/shared/Description'
import { getAlternates } from '../../lib/helper/helper'
import CustomGrid from '../../components/structure/CustomGrid'

interface StateProps {
  state: State
  settings: any
}

const StatePage: NextPage<StateProps> = ({ state }: StateProps) => {
  const {
    name,
    nameDescription,
    h1,
    coverImage,
    _id,
    _type,
    meta_title,
    meta_description,
    faq,
    description_1,
    description_2,
    description_3,
    reviews,
    number_activities,
    number_locations,
    product_link,
  } = state

  return (
    <>
      <PageHead
        meta_title={meta_title}
        meta_description={meta_description}
        alternates={getAlternates(state)}
        coverImage={coverImage}
        wildcards={{ number_activities, number_locations }}
        item={state}
        faqs={faq}
      />
      <PageBanner
        coverImage={coverImage}
        name={name}
        nameDescription={nameDescription}
        h1={h1}
        wildcards={{ number_activities, number_locations }}
        product_link={product_link}
      />
      <TileSlider
        labelKey={'cities-in-location'}
        location={name}
        loadWith={getGetAllCitiesInState(_id)}
      />
      <TileSlider
        labelKey={'categories-in-location'}
        location={name}
        keepLocation
        loadWith={getGetAllCategoriesInState(_id)}
        type={'category'}
      />
      <CustomGrid
        loadWith={getGetAllProductsInLocation(_type, _id)}
        location={name}
        addAsSchema
      />
      {!!faq?.length && faq !== null && faq.length > 0 && (
        <FAQ faqs={faq} nameEntity={name} />
      )}
      {description_1 && !!description_1.length && (
        <Description
          description={description_1}
          withBorder
          nameLocation={name}
          {...reviews}
        />
      )}
      {description_2 && !!description_2.length && (
        <Description description={description_2} withBorder />
      )}
      {description_3 && !!description_3.length && (
        <Description description={description_3} withBorder />
      )}
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { params, preview, locale } = context
  const { state: stateSlug } = params
  const client = getClient(preview ? { token: readToken } : undefined)
  const [state, translations] = await Promise.all([
    getStateBySlug(locale as AppLocale, client, stateSlug as string),
    serverSideTranslations(locale, ['common']),
  ])

  if (!state) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      ...translations,
      state,
    },
  }
}

export default StatePage
